

jQuery(function($){
    function JVmasonryLayout() {
      
      if ($(".shop-products-list .product_list_widget .itemMasonry").length > 0) {
      
      var $container = $('.shop-products-list .product_list_widget').imagesLoaded(function(){
          $container.masonry({
          itemSelector: '.itemMasonry'
          });
      });
        
      }  
        
    }

    JVmasonryLayout();
  	window.JVmasonryLayout = JVmasonryLayout;  
  
});
